"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));

var _Hidden = _interopRequireDefault(require("@material-ui/core/Hidden"));

var _reactRedux = require("react-redux");

var _notistack = require("notistack");

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _Search = _interopRequireDefault(require("@material-ui/icons/Search"));

var _nicaLocatorCore = require("../../nicaLocatorCore");

var _radiusSelect = _interopRequireDefault(require("../../_common/radiusSelect"));

var _selectors = require("../../../redux/locations/selectors");

var _actions = require("../../../redux/locations/actions");

var _selectors2 = require("../../../redux/login/selectors");

require("./index.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var LocatorHeader = function LocatorHeader() {
  var _useState = (0, _react.useState)(''),
      _useState2 = _slicedToArray(_useState, 2),
      search = _useState2[0],
      setSearch = _useState2[1];

  var _useSearchSelector = (0, _selectors.useSearchSelector)(),
      loading = _useSearchSelector.loading,
      searchRadius = _useSearchSelector.searchRadius,
      filter = _useSearchSelector.filter;

  var dispatch = (0, _reactRedux.useDispatch)();
  var inputRef = (0, _react.useRef)(null);

  var _useSnackbar = (0, _notistack.useSnackbar)(),
      enqueueSnackbar = _useSnackbar.enqueueSnackbar;

  var _useLoginSelector = (0, _selectors2.useLoginSelector)(),
      userIP = _useLoginSelector.userIP,
      isBlacklisted = _useLoginSelector.isBlacklisted,
      blockCountry = _useLoginSelector.blockCountry;

  var _useContext = (0, _react.useContext)(_nicaLocatorCore.AppContext),
      WelcomeHeaderComponent = _useContext.components.WelcomeHeaderComponent,
      logo = _useContext.images.logo,
      headerLabel = _useContext.strings.headerLabel;

  var onSearch = function onSearch() {
    if (search.length > 3) {
      inputRef.current.blur();
      dispatch((0, _actions.searchByQuery)(search, searchRadius, filter, enqueueSnackbar));
    }
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "locator-form-header"
  }, WelcomeHeaderComponent ? /*#__PURE__*/_react.default.createElement(WelcomeHeaderComponent, null) : /*#__PURE__*/_react.default.createElement("div", {
    className: "flex text-align-left align-items-center justify-content-center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex1"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: "https://infusioncenter.org",
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: logo,
    className: "locator-form-header-logo",
    alt: "locator header"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "locator-form-header-title headlineFont"
  }, headerLabel || "INFUSION CENTER LOCATOR")), /*#__PURE__*/_react.default.createElement("div", {
    className: "marginTop20"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "locator-form-search-box flex align-items-center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex flex1"
  }, /*#__PURE__*/_react.default.createElement("input", {
    className: "locator-form-search-input flex1 headlineFont",
    name: "search",
    maxLength: "200",
    autoComplete: "off",
    value: search,
    onChange: function onChange(event) {
      return setSearch(event.target.value);
    },
    onKeyDown: function onKeyDown(event) {
      if (event.keyCode === 13) {
        onSearch();
      }
    },
    placeholder: "City and State, or ZIP",
    ref: inputRef
  })), /*#__PURE__*/_react.default.createElement(_Hidden.default, {
    xsDown: true
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "marginLeft10 marginRight10"
  }, /*#__PURE__*/_react.default.createElement(_radiusSelect.default, {
    className: "locator-form-distance-select bodyFont",
    disableUnderline: true
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "locator-form-search-button-container flex align-items-center justify-content-center"
  }, userIP && loading ? /*#__PURE__*/_react.default.createElement(_CircularProgress.default, {
    size: 30
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Hidden.default, {
    xsDown: true
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "contained",
    color: "secondary",
    disableElevation: true,
    onClick: onSearch,
    disabled: !userIP || isBlacklisted || blockCountry
  }, "Search")), /*#__PURE__*/_react.default.createElement(_Hidden.default, {
    smUp: true
  }, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    onClick: onSearch,
    disabled: !userIP || isBlacklisted || blockCountry
  }, /*#__PURE__*/_react.default.createElement(_Search.default, null))))))));
};

var _default = LocatorHeader;
exports.default = _default;